/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Container,
} from "reactstrap";

import  secureLocalStorage  from  "react-secure-storage";


const Header = () => {

    const user = JSON.parse(secureLocalStorage.getItem("user"));    
    return (
        <>
            <div className="header pb-4 pt-5 justify-content-center bg-white">
                <Container fluid>
                    <div className="header-body text-center">
                        <h1>Central System</h1>
                        <h3>Welcome, {user.name}!</h3>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Header;
